import React from "react";
import { useLang } from "@/context/LanguageContext";
import { AlertTriangle } from "lucide-react";

const COPY = {
  en: "Do not upload passwords, Social Security numbers, financial-account information, confidential attorney-client communications, or other sensitive information unless specifically necessary.",
  es: "No subas contraseñas, números de Seguro Social, información de cuentas bancarias, comunicaciones confidenciales entre abogado y cliente ni otra información sensible a menos que sea estrictamente necesario.",
};

export function SensitiveInfoWarning({ testid = "sensitive-warning" }) {
  const { lang } = useLang();
  return (
    <div
      data-testid={testid}
      className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-3 flex gap-2 items-start"
    >
      <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" />
      <span>{COPY[lang] || COPY.en}</span>
    </div>
  );
}
